<template>
  <div v-if="isH5 == false" class="home">
    <el-container>
      <el-header>
        <div style="max-width: 100%; margin: 0 auto; background-color: #175cc4;">
          <div class="content">
            <el-row>
              <div class="pheader-pc-brand">
                <img
                  class="pheader-pc-brand__logo"
                  :src="require('@/assets/hcvt_logo_pc.png')"
                  alt=""
                />
                <div class="pheader-pc-brand__title">{{ title }}</div>
              </div>
            </el-row>
          </div>
          <div class="content">
            <el-row>
              <el-col :span="24">
                <div class="pheader-menu-row">
                  <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo pheader__el-menu"
                    mode="horizontal"
                    @select="handleSelect"
                  >
                    <el-menu-item index="Index">首页</el-menu-item>
                    <!--<el-menu-item index="DigitalCommerceServices">数字商贸服务专业教学资源库</el-menu-item>-->
                    <!--<el-menu-item index="InternationalTourism">国际旅游专业教学资源库</el-menu-item>-->
                    <el-menu-item index="CourseMajorDisplay">专业课程</el-menu-item>
                    <el-menu-item index="Home">课程中心</el-menu-item>
                    <el-menu-item index="https://www.zhihuishu.com/portals_h5/2clearning.html#/courseSearch?keyword=%E6%B5%B7%E5%8D%97%E8%81%8C%E4%B8%9A%E6%8A%80%E6%9C%AF%E5%AD%A6%E9%99%A2">智慧树</el-menu-item>
                    <el-menu-item index="https://hcvt.fanya.chaoxing.com/portal">超星泛雅</el-menu-item>
                    <el-menu-item index="https://zjy2.icve.com.cn/schoolhomepage/hcvt?schoolId=ljybaeinp5rbcbh7zrln-g">职教云</el-menu-item>
                  </el-menu>
                  <div v-if="catalogUserBarLabel" class="pheader__user-chip" :title="catalogUserBarTitle || catalogUserBarLabel">
                    <div class="pheader__user-avatar" aria-hidden="true">{{ userBarInitial }}</div>
                    <span class="pheader__user-name">{{ catalogUserBarLabel }}</span>
                    <button
                      type="button"
                      class="pheader__user-out"
                      aria-label="注销登录"
                      @click="handleCatalogUserLogout"
                    >
                      注销
                    </button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-header>
    </el-container>
  </div>
  <!--
    H5：仅一条薄顶栏（约 44px + 安全区 + placeholder），不占 PC 那种大块头；
    左菜单 · 中小 Logo · 右登录条；全站入口仍在侧滑抽屉，与 PC 菜单项一致。
  -->
  <div v-else class="h5 pheader-h5-mobile">
    <van-nav-bar fixed placeholder safe-area-inset-top class="pheader-h5-navbar">
      <template #left>
        <div
          class="pheader-h5-leftentry"
          role="button"
          tabindex="0"
          aria-label="打开导航菜单"
          @click="h5NavOpen = true"
          @keydown.enter.prevent="h5NavOpen = true"
        >
          <van-icon name="bars" class="pheader-h5-leftentry__ico" />
          <span class="pheader-h5-leftentry__txt">菜单</span>
        </div>
      </template>
      <template #title>
        <div class="pheader-h5-bartitle" :title="title">
          <van-image
            class="pheader-h5-bartitle__logo"
            fit="contain"
            :src="require('@/assets/hcvt_logo_h5.png')"
          />
        </div>
      </template>
      <template #right>
        <div
          v-if="catalogUserBarLabel"
          class="pheader-h5-baruser"
          :title="catalogUserBarTitle || catalogUserBarLabel"
        >
          <span class="pheader-h5-baruser__dot" aria-hidden="true">{{ userBarInitial }}</span>
          <button type="button" class="pheader-h5-baruser__out" aria-label="注销登录" @click="handleCatalogUserLogout">
            注销
          </button>
        </div>
      </template>
    </van-nav-bar>
    <van-popup
      v-model:show="h5NavOpen"
      position="left"
      teleport="body"
      class="pheader-h5-nav-popup"
      :style="{ width: 'min(280px, 82vw)', height: '100%' }"
    >
      <div class="pheader-h5-drawer">
        <div class="pheader-h5-drawer__head">
          <van-image
            class="pheader-h5-drawer__logo"
            fit="contain"
            :src="require('@/assets/hcvt_logo_h5.png')"
          />
          <div class="pheader-h5-drawer__head-meta">
            <div class="pheader-h5-drawer__head-title">{{ title }}</div>
            <div class="pheader-h5-drawer__head-sub">请选择入口</div>
          </div>
        </div>
        <button
          v-for="nav in h5NavItems"
          :key="nav.key"
          type="button"
          class="pheader-h5-drawer__item"
          :class="{ 'pheader-h5-drawer__item--active': isH5NavItemActive(nav.key) }"
          @click="onH5NavItem(nav.key)"
        >
          {{ nav.label }}
        </button>
      </div>
    </van-popup>
  </div>
</template>


<script>
import { showNotify } from 'vant'
import {
  readCatalogUserDisplay,
  readCatalogUserTitle,
  clearMajorCatalogSession,
  MAJOR_CATALOG_AUTH_CHANGED_EVENT,
} from '@/common/js/majorCatalogSession'

/** 与 PC 顶栏 el-menu 项保持一致（H5 侧滑菜单） */
const PHEADER_H5_NAV_ITEMS = Object.freeze([
  { key: 'Index', label: '首页' },
  { key: 'CourseMajorDisplay', label: '专业课程' },
  { key: 'Home', label: '课程中心' },
  {
    key: 'https://www.zhihuishu.com/portals_h5/2clearning.html#/courseSearch?keyword=%E6%B5%B7%E5%8D%97%E8%81%8C%E4%B8%9A%E6%8A%80%E6%9C%AF%E5%AD%A6%E9%99%A2',
    label: '智慧树',
  },
  { key: 'https://hcvt.fanya.chaoxing.com/portal', label: '超星泛雅' },
  {
    key: 'https://zjy2.icve.com.cn/schoolhomepage/hcvt?schoolId=ljybaeinp5rbcbh7zrln-g',
    label: '职教云',
  },
])

export default {
  name: 'headerIndex',
  components: {
  },
  props: {
    activeIndex: {
      type: String,
      default: () => '/Index',
    },
  },
  setup(){
    return {
      title: "教学资源平台"
    }
  },
  data(){
    return {
      showH5Title:false,
      isH5:false,
      queryObject:{},
      /** 与 sessionStorage 配合，驱动顶栏用户展示刷新 */
      catalogAuthTick: 0,
      /** H5 侧滑导航 */
      h5NavOpen: false,
    }
  },
  computed: {
    h5NavItems() {
      return PHEADER_H5_NAV_ITEMS
    },
    catalogUserBarLabel() {
      void this.catalogAuthTick
      return readCatalogUserDisplay()
    },
    catalogUserBarTitle() {
      void this.catalogAuthTick
      return readCatalogUserTitle()
    },
    /** 顶栏头像：展示名首字 */
    userBarInitial() {
      void this.catalogAuthTick
      const s = (readCatalogUserDisplay() || '').trim()
      if (!s) return '用'
      const ch = s.charAt(0)
      return /[\u4e00-\u9fff]/.test(ch) ? ch : ch.toUpperCase()
    },
  },
  mounted(){
    // 添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.checkScreenSize);
    window.addEventListener(MAJOR_CATALOG_AUTH_CHANGED_EVENT, this.bumpCatalogAuthTick)
    // 初始化时检查屏幕大小
    this.checkScreenSize();
  },
  methods:{
    checkScreenSize() {
      // 使用媒体查询判断屏幕大小
      this.isH5 = this.$utils.checkScreenSize();
    },
    handleSelect(key, keyPath){
      console.log(key, keyPath)
      if (key.startsWith("Home_")){
        key = 'Home'
      }
      
      if (key.startsWith('http')){
        this.$utils.windowOpen(key)
      }else{
        this.$router.push({
          name: key
        });
      }
    },
    isH5NavItemActive(key) {
      if (!key || String(key).startsWith('http')) return false
      return this.activeIndex === key
    },
    onH5NavItem(key) {
      this.h5NavOpen = false
      this.handleSelect(key, [])
    },
    bumpCatalogAuthTick() {
      this.catalogAuthTick++
    },
    handleCatalogUserLogout() {
      clearMajorCatalogSession()
      showNotify({ type: 'success', message: '已退出登录' })
    },
  },
  beforeUnmount() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener('resize', this.checkScreenSize);
    window.removeEventListener(MAJOR_CATALOG_AUTH_CHANGED_EVENT, this.bumpCatalogAuthTick)
  }
}
</script>

<style scoped>
.home{
  background-color: #175cc4;
  height: 160px;
}

.home .content{
  background-color: #175cc4;
  max-width: 80%; /* 设置内容区域最大宽度 */
  margin: 0 auto; /* 自动左右边距实现居中 */
}

/* PC 顶栏品牌：钉钉 WebView 里 el-image 易被拉成整行宽，改用 flex + 原生 img */
.pheader-pc-brand {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  min-height: 80px;
  padding: 10px 0 12px;
  box-sizing: border-box;
  max-width: 100%;
  text-align: left;
}

.pheader-pc-brand__logo {
  flex-shrink: 0;
  display: block;
  height: 56px;
  width: auto;
  max-width: min(300px, 52vw);
  max-height: 72px;
  object-fit: contain;
  object-position: left center;
}

.pheader-pc-brand__title {
  margin: 0;
  min-width: 0;
  flex: 1;
  font-size: clamp(16px, 2.2vw, 24px);
  font-weight: 600;
  color: #fff;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-main {
  --el-main-padding: 0px;
}

.el-header {
  --el-header-padding: 0 0px;
}

.el-menu{
  background-color: #175cc4;
  color: white;
}

.el-menu-demo .el-menu-item{
  color: white;
  background-color: #175cc4!important;
}
.el-menu-demo .el-menu-item:hover{
  color: white;
  background-color: #175cc4!important;
}
.el-menu-demo .el-submenu__title{
  color: white;
  background-color: #175cc4!important;
}
.el-menu-demo .el-submenu__title:hover{
  color: white;
  background-color: #175cc4!important;
}

.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 2px solid white;
  background-color: #175cc4;
  color: white !important;
}

.el-menu--horizontal.el-menu {
    border-bottom: solid 0px var(--el-menu-border-color);
}

.el-menu--horizontal>.el-menu-item{
  color: white !important
}

.el-menu--horizontal>.el-menu-item:hover{
  border-bottom: 2px solid white;
  color: white !important
}

.pheader-menu-row {
  display: flex;
  align-items: center;
  gap: 8px 12px;
  flex-wrap: nowrap;
  min-width: 0;
}

.pheader__el-menu {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
}

/* PC：紧凑毛玻璃条（头像 + 单行名 + 注销） */
.pheader__user-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  max-width: min(240px, 32vw);
  padding: 2px 5px 2px 2px;
  margin-left: 4px;
  border-radius: 999px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.09) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.32);
  box-shadow:
    0 2px 10px rgba(0, 40, 120, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.pheader__user-avatar {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #175cc4;
  background: linear-gradient(160deg, #ffffff 0%, #e8f2ff 100%);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.75);
}

.pheader__user-name {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: #fff;
  text-shadow: 0 1px 1px rgba(0, 30, 80, 0.2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pheader__user-out {
  flex-shrink: 0;
  margin: 0;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: #175cc4;
  background: rgba(255, 255, 255, 0.92);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 35, 90, 0.12);
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease;
}

.pheader__user-out:hover {
  background: #fff;
  color: #0d4a9e;
  box-shadow: 0 2px 8px rgba(0, 35, 90, 0.16);
}

.pheader__user-out:active {
  transform: scale(0.97);
}

/* ========== H5：薄顶栏（单行） ========== */
.pheader-h5-mobile {
  position: relative;
  z-index: 1000;
}

/* Vant 4 顶栏内层默认白底，需同时设变量 + 内层背景，否则图标与背景同色「看不见」 */
.pheader-h5-navbar {
  --van-nav-bar-background: #175cc4;
  --van-nav-bar-title-text-color: #fff;
  --van-nav-bar-icon-color: #fff;
  --van-nav-bar-text-color: #fff;
  background: #175cc4 !important;
}

.pheader-h5-navbar :deep(.van-nav-bar),
.pheader-h5-navbar :deep(.van-nav-bar__content) {
  background-color: #175cc4 !important;
}

.pheader-h5-navbar :deep(.van-nav-bar__placeholder) {
  background-color: #175cc4;
}

.pheader-h5-navbar :deep(.van-nav-bar__content) {
  height: 46px;
}

.pheader-h5-navbar :deep(.van-nav-bar__arrow),
.pheader-h5-navbar :deep(.van-icon) {
  color: #fff !important;
}

.pheader-h5-navbar :deep(.van-nav-bar__title) {
  max-width: 46vw;
  margin: 0 auto;
}

.pheader-h5-leftentry {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px 6px 4px;
  margin-left: -6px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.pheader-h5-leftentry__ico {
  font-size: 22px;
  line-height: 1;
}

.pheader-h5-leftentry__txt {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.pheader-h5-bartitle {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
}

.pheader-h5-bartitle__logo {
  display: block;
  height: 24px;
  width: auto;
  max-width: min(140px, 40vw);
}

/* 顶栏右侧：紧凑用户条（不占过宽） */
.pheader-h5-baruser {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 42vw;
  margin-right: -4px;
}

.pheader-h5-baruser__dot {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #175cc4;
  background: linear-gradient(160deg, #fff 0%, #e8f0ff 100%);
  border: 1px solid rgba(255, 255, 255, 0.9);
}

.pheader-h5-baruser__out {
  flex-shrink: 0;
  margin: 0;
  padding: 5px 9px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: #175cc4;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 35, 90, 0.12);
}

.pheader-h5-baruser__out:active {
  opacity: 0.88;
}

.pheader-h5-drawer {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 0 calc(12px + env(safe-area-inset-bottom, 0px));
  background: #f5f7fa;
  box-sizing: border-box;
}

.pheader-h5-drawer__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px 14px;
  border-bottom: 1px solid #e4e7ed;
  background: #fff;
}

.pheader-h5-drawer__logo {
  flex-shrink: 0;
  width: 72px;
  height: 36px;
}

.pheader-h5-drawer__head-meta {
  min-width: 0;
  flex: 1;
}

.pheader-h5-drawer__head-title {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
  line-height: 1.3;
}

.pheader-h5-drawer__head-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.pheader-h5-drawer__item {
  display: block;
  width: 100%;
  margin: 0;
  padding: 11px 16px;
  text-align: left;
  font-size: 14px;
  color: #303133;
  background: transparent;
  border: none;
  border-left: 3px solid transparent;
  cursor: pointer;
}

.pheader-h5-drawer__item:active {
  background: rgba(23, 92, 196, 0.08);
}

.pheader-h5-drawer__item--active {
  color: #175cc4;
  font-weight: 600;
  background: rgba(23, 92, 196, 0.06);
  border-left-color: #175cc4;
}

/* 高于页面内 tabbar / 浮钮，避免抽屉被挡住 */
.pheader-h5-nav-popup.van-popup {
  z-index: 2100;
}

</style>
